export default "__VITE_ASSET__C9h6QDT8__"